import { render, staticRenderFns } from "./cafebazar.vue?vue&type=template&id=3e68b8d4"
import script from "./cafebazar.vue?vue&type=script&lang=js"
export * from "./cafebazar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports